import React from 'react';
import { connect } from 'react-redux';
import FooterSectionView from './footer-section-view';
import {
  createSectionLinkT,
  removeFooterSectionT,
  removeSectionLinkT,
  setLinkTitleT, setLinkUriT,
  setSectionLinksT,
  setSectionTitleT
} from "../../../../../state/actions/shared/section";

const FooterSectionRedux = (props) => (
  <FooterSectionView {...props}/>
);

const mapStateToProps = (state, ownProps) => {
  const {id:sectionId, index:sectionIndex} = ownProps;
  const articleEntities = state.articles.article;
  const {sections} = articleEntities;
  const currentSection = sections[sectionId];
  const {title, links} = currentSection || {};
  return{
    index: sectionIndex,
    title,
    links: links || [],
    id: sectionId,
    readOnly: state.versions.readOnly,
  }
};


const mapDispatchToProps = (dispatch, ownProps) => {
  const {articleId, id:sectionId} = ownProps;
  const defaultLink = {title: '', uri: ''};
  return {
    onDeleteSection: () => dispatch(removeFooterSectionT('article', articleId, sectionId)),
    onTitleChange: (text) => dispatch(setSectionTitleT('article', sectionId, text)),
    onAddLink: () => dispatch(createSectionLinkT('article', sectionId, defaultLink)),
    onLinkTitleChange: (linkId, text) => dispatch(setLinkTitleT('article', sectionId, linkId, text)),
    onLinkUriChange : (linkId, text) => dispatch(setLinkUriT('article', sectionId, linkId, text)),
    onLinkOrderChange: (list) => dispatch(setSectionLinksT('article', sectionId, list)),
    onDeleteLink: (linkId) => dispatch(removeSectionLinkT('article', sectionId, linkId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterSectionRedux);
